<template>
  <div class="product-delivery">
    <p class="product-delivery__title">
      {{ $t('Delivery information') }}
    </p>

    <div class="delivery-item product-delivery__item">
      <div class="delivery-item__icon">
        <MapPin />
      </div>

      <div class="delivery-item__address">
        <p v-if="deliveryAddress">{{ $t('Delivery to address') }} {{ warehouseAddressString(deliveryAddress) }}</p>

        <p v-else>
          {{ $t('Delivery available') }}
        </p>

        <span>{{ $t('Delivery is carried out by the seller') }}</span>
      </div>
    </div>

    <div class="delivery-item product-delivery__item">
      <div class="delivery-item__icon">
        <MapPin />
      </div>

      <div class="delivery-item__address">
        <p v-if="pickupAddress">
          {{ $t('Pickup at address') }} {{ warehouseAddressString(pickupAddress, { withAddress: false }) }}
        </p>
        <p v-else>
          {{ $t('Pickup available') }}
        </p>

        <span>
          {{ $t('Pickup at the collection point address') }}.
          <span v-if="pickupAddress"> {{ $t('You may choose another pick-up point') }}. </span></span
        >
      </div>
    </div>
  </div>
</template>

<script>
import { warehouseAddressString } from '@/helpers/warehouseAddressString'
import { MapPin } from 'lucide-vue'

export default {
  name: 'ProductPageDelivery',
  components: {
    MapPin,
  },
  props: {
    product: {
      type: Object,
      required: true,
    },
    deliveryAddress: {
      type: Object,
      required: false,
    },
    pickupAddress: {
      type: Object,
      required: false,
    },
  },
  methods: {
    warehouseAddressString,
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common-imports.scss';

.product-delivery {
  padding: 12px 16px;
  display: grid;
  gap: 8px;
  grid-template-columns: 1fr;
  background-color: $White;
  border-radius: 4px;
  box-shadow: 3px 6px 12px rgba(0, 0, 0, 0.2);
  font-size: 14px;
  line-height: 16px;

  @include media-breakpoint-up(xl) {
    padding: 20px 30px;
    font-size: 16px;
    line-height: 18px;
    gap: 12px;
    box-shadow: 5px 10px 20px rgba(0, 0, 0, 0.2);
    border-radius: 8px;
  }

  &__title {
    font-weight: 600;
  }
}

.delivery-item {
  display: grid;
  gap: 4px;
  grid-template-columns: 18px 1fr;
  font-size: 14px;
  line-height: 16px;

  @include media-breakpoint-up(xl) {
    font-size: 16px;
    line-height: 18px;
    gap: 8px;
  }

  &__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    color: $DGray;

    > svg {
      width: 14px;
      height: 14px;

      @include media-breakpoint-up(xl) {
        width: 16px;
        height: 16px;
      }
    }
  }

  &__address {
    font-weight: 500;
    display: flex;
    flex-direction: column;
    display: flex;

    @include media-breakpoint-up(xl) {
      gap: 2px;
    }

    span {
      font-weight: 400;
      font-size: 12px;
      line-height: 14px;

      @include media-breakpoint-up(xl) {
        font-size: 14px;
        line-height: 16px;
      }
    }
  }
}
</style>
